import { useLayoutEffect } from 'react';
import { setRtfCopyOwner } from './rtf-copy-state';
import { useRtfCopy } from './useRtfCopy';

/** Mounted at desktop auth; keeps native routing active while the session is open. */
export function useRtfCopyIdentity(ownerId: string | null): void {
  useLayoutEffect(() => {
    setRtfCopyOwner(ownerId);
    return () => setRtfCopyOwner(null);
  }, [ownerId]);
  // Validate native support on sign-in/reload, without requiring the menu to open.
  useRtfCopy();
}
